
import React from 'react';
import { Badge } from '@/components/ui/badge';

interface CalendarLegendProps {
  productGroups: Record<string, { color: string, count: number }>;
}

export const CalendarLegend: React.FC<CalendarLegendProps> = ({ productGroups }) => {
  return (
    <div className="flex flex-wrap gap-2 mb-4">
      {Object.entries(productGroups).map(([product, { color, count }]) => (
        <Badge key={product} variant="outline" className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full" style={{ backgroundColor: color }} />
          <span>{product} ({count})</span>
        </Badge>
      ))}
    </div>
  );
};
